import React, { useEffect, useRef } from 'react';
import "./style.scss";
import Chart from 'chart.js/auto';

const BarComponent = ({ trendData, title }) => {

    const chartRef = useRef(null);

    useEffect(() => {

        if (chartRef && chartRef.current) {
            const ctx = chartRef.current.getContext('2d');

            const labels = trendData && trendData?.length && trendData?.map(data => data?.date || data?.month || data?.hour || data?.day);
            const values = trendData && trendData?.length && trendData?.map(data => data.totalApplications);

            const data = {
                labels: labels,
                datasets: [{
                    data: values,
                    backgroundColor: [
                        '#14FB55',
                        '#14FB55',
                        '#14FB55',
                        '#14FB55',
                        '#14FB55',
                        '#14FB55',
                        '#14FB55'
                    ],
                    borderColor: [
                        'rgb(255, 99, 132)',
                        'rgb(255, 159, 64)',
                        'rgb(255, 205, 86)',
                        'rgb(75, 192, 192)',
                        'rgb(54, 162, 235)',
                        'rgb(153, 102, 255)',
                        'rgb(201, 203, 207)'
                    ],
                    borderWidth: 1
                }]
            }

            const config = {
                type: "bar",
                data: data,
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        },
                        x: {
                            categorySpacing: 0.9,
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        }
                    }

                }
            }

            const myChart = new Chart(ctx, config);

            return () => {
                myChart.destroy();
            };
        }
    }, [trendData]);

    return (
        <div className='bar-chart'>
            <h3>Cases punched {title}</h3>
            <canvas ref={chartRef}></canvas>
        </div>
    )
}

export default BarComponent;
